AbilitiesHelper = LP.module 'AbilitiesHelper'
AbilitiesHelper.site = ->
  $('.' + ability).toggle(access) for ability, access of LP.config.abilities if LP.config.abilities?
  $('.js-show-logged-in').toggle(LP.config.logged_in) if LP.config.logged_in?
  # Hide the fixed-footer when logged in
  if LP.config.logged_in
    $('.js-hide-logged-in').hide() 
  